export const notEmpty = <T>(
  value: T | false | undefined | null | '' | 0
): value is T => !!value;
